import React from 'react';
import ServicesPage from './pages/ServicesPage'; // Adjust the path based on the file location

function App() {
  return <ServicesPage />;
}

export default App;